import styled, { DefaultTheme } from 'styled-components';

import { CustomLinkSubStatus } from '../../../../models/payment-links-custom';
import { SizeAllowed } from '.';

interface StatusProps {
	readonly subStatus: CustomLinkSubStatus;
	readonly size?: SizeAllowed;
	readonly borderFull?: boolean;
}

const getColor = (subStatus: CustomLinkSubStatus, theme: DefaultTheme, size?: string) => {
	if (subStatus === 'finalized' || subStatus === 'completed' || subStatus === 'expired') {
		return {
			bg: theme.colors.principal.ceres,
			color: theme.colors.principal.orion,
			border: theme.colors.extra.space_600,
		};
	} else if (subStatus === 'pending' || subStatus === 'paused') {
		return {
			bg: theme.colors.extra.saturn_100,
			color: theme.colors.principal.orion,
			border: theme.colors.extra.saturn_500,
		};
	} else {
		return {
			bg: theme.colors.principal['light-alamak'],
			color: size === 'sm' ? theme.colors.principal.vanth : theme.colors.principal.orion,
			border: theme.colors.principal.alamak,
		};
	}
};

export const StatusContainer = styled.div<StatusProps>`
	align-items: center;
	background-color: ${({ subStatus, theme }) => getColor(subStatus, theme).bg};
	border-radius: 4px;
	${({ borderFull, subStatus, theme }) =>
		borderFull ? `border: 1px solid ${getColor(subStatus, theme).border};` : null}

	box-sizing: border-box;
	display: flex;
	justify-content: center;
	min-height: 24px;
	padding: 6px;
	width: max-content;
`;

export const Label = styled.span<StatusProps>`
	align-items: flex-end;
	color: ${({ subStatus, theme, size }) => getColor(subStatus, theme, size).color};
	display: flex;
	font-size: ${({ size }) => (size === 'sm' ? '11px' : '12px')};
	font-weight: 400;
	line-height: 12px;
	vertical-align: baseline;
`;
